import { type Type } from '@angular/core';
import { type PartialDeep } from 'type-fest';

import { type CanvasElementType, type PartialPropsOf } from '@blaze-runtime/engine-domain';
import {
  type PropertiesConfigInputVisualEffectModel,
  type VisibilityAccessRoleRef,
} from '@blaze-shared/elements-domain';

import { extractElementVisibilityAccessRoles } from '../../canvas-elements/element-model/props-extractor';

export class PropsExtractor<T extends CanvasElementType> {
  setProps = (props: PartialPropsOf<T> | undefined): void => {
    this.props = props;
  };
  getPageReferences: () => string[] = () => [];

  getVisualEffect: () => PartialDeep<PropertiesConfigInputVisualEffectModel> | undefined = () =>
    undefined;

  constructor(protected props: PartialPropsOf<T> | undefined) {}

  getVisibilityAccessRolesRefs(): VisibilityAccessRoleRef[] {
    /** get element level visibility access roles refs */
    if (!(this.props && 'content' in this.props) || !this.props?.content) {
      return [];
    }
    const elementAccess = extractElementVisibilityAccessRoles(this.props);
    return elementAccess ? [elementAccess] : [];
  }
}

declare module '../../canvas-elements/element-definition' {
  interface CanvasElementDefinition<
    T extends CanvasElementType = CanvasElementType,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    TVariant extends CanvasElementType = T,
  > {
    /** Props Builder implementation class */
    propsExtractor?: Type<PropsExtractor<T>>;
  }
}
